import { hydrateStores } from '../stores/hydrate-stores'
import App from './app.svelte'

export default function hydrate(el, props) {
  hydrateStores(props)
  // eslint-disable-next-line no-unused-vars
  const app = new App({
    target: el,
    hydrate: true,
    props: {},
  })
}
